import React, { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

interface ZoomableImageProps {
  src: string;
}

const ZoomableImage: React.FC<ZoomableImageProps> = ({ src }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleOpenFullScreen = () => {
    setIsFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreen(false);
  };

  return (
    <>
      {!isFullScreen && (
        <img
          src={src}
          alt={"Unsupported Image"}
          onClick={handleOpenFullScreen}
          title="Click to Zoom"
          style={{
            width: "auto",
            height: "auto",
            maxWidth: "80%",
            maxHeight: "60%",
            cursor: "pointer",
          }}
        />
      )}

      {/* Full-Screen Zoom */}
      {isFullScreen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Close Button */}
          <button
            onClick={handleCloseFullScreen}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "28px",
              color: "white",
              cursor: "pointer",
              zIndex: 1100,
            }}
          >
            &times;
          </button>

          <TransformWrapper>
            <TransformComponent>
              <img
                src={src}
                alt={"Unsupported Image"}
                style={{ width: "900px", height: "700px" }}
              />
            </TransformComponent>
          </TransformWrapper>
        </div>
      )}
    </>
  );
};

export default ZoomableImage;
